import { render } from "./vcorporatetransferbankcardadd.vue?vue&type=template&id=159653e8&scoped=true"
import script from "./vcorporatetransferbankcardadd.vue?vue&type=script&lang=js"
export * from "./vcorporatetransferbankcardadd.vue?vue&type=script&lang=js"

import "./vcorporatetransferbankcardadd.vue?vue&type=style&index=0&id=159653e8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159653e8"]])

export default __exports__